import { render, staticRenderFns } from "./EditModelClientArea.vue?vue&type=template&id=36224db2&"
import script from "./EditModelClientArea.vue?vue&type=script&lang=js&"
export * from "./EditModelClientArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports